import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerTokenDetailFragment = { __typename?: 'CustomerToken', id: string, clientId: string, environmentId: string, enabled?: boolean | null, role: Types.CredentialRole, name: string, created: string, updated: string };

export type CustomerTokenListQueryVariables = Types.Exact<{
  cursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.CustomerTokensOrderBy> | Types.CustomerTokensOrderBy;
}>;


export type CustomerTokenListQuery = { __typename?: 'Query', customerTokens?: { __typename?: 'CustomerTokensConnection', totalCount: number, nodes: Array<{ __typename?: 'CustomerToken', id: string, clientId: string, environmentId: string, enabled?: boolean | null, role: Types.CredentialRole, name: string, created: string, updated: string }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UpdateCustomerTokenMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  environmentId: Types.Scalars['String']['input'];
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateCustomerTokenMutation = { __typename?: 'Mutation', updateCustomerToken?: { __typename?: 'UpdateCustomerTokenPayload', customerToken?: { __typename?: 'CustomerToken', id: string, clientId: string, environmentId: string, enabled?: boolean | null, role: Types.CredentialRole, name: string, created: string, updated: string } | null } | null };

export type DeleteCustomerTokenMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteCustomerTokenMutation = { __typename?: 'Mutation', deleteCustomerToken?: { __typename?: 'DeleteCustomerTokenPayload', customerToken?: { __typename?: 'CustomerToken', id: string, clientId: string, environmentId: string, enabled?: boolean | null, role: Types.CredentialRole, name: string, created: string, updated: string } | null } | null };

export const CustomerTokenDetailFragmentDoc = gql`
    fragment CustomerTokenDetail on CustomerToken {
  id
  clientId
  environmentId
  enabled
  role
  name
  created
  updated
}
    `;
export const CustomerTokenListDocument = gql`
    query CustomerTokenList($cursor: Cursor, $environmentId: String!, $orderBy: [CustomerTokensOrderBy!]! = [PRIMARY_KEY_ASC]) {
  customerTokens(
    first: 20
    orderBy: $orderBy
    after: $cursor
    condition: {environmentId: $environmentId}
  ) {
    nodes {
      ...CustomerTokenDetail
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CustomerTokenDetailFragmentDoc}`;

/**
 * __useCustomerTokenListQuery__
 *
 * To run a query within a React component, call `useCustomerTokenListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTokenListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTokenListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCustomerTokenListQuery(baseOptions: Apollo.QueryHookOptions<CustomerTokenListQuery, CustomerTokenListQueryVariables> & ({ variables: CustomerTokenListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTokenListQuery, CustomerTokenListQueryVariables>(CustomerTokenListDocument, options);
      }
export function useCustomerTokenListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTokenListQuery, CustomerTokenListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTokenListQuery, CustomerTokenListQueryVariables>(CustomerTokenListDocument, options);
        }
export function useCustomerTokenListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerTokenListQuery, CustomerTokenListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerTokenListQuery, CustomerTokenListQueryVariables>(CustomerTokenListDocument, options);
        }
export type CustomerTokenListQueryHookResult = ReturnType<typeof useCustomerTokenListQuery>;
export type CustomerTokenListLazyQueryHookResult = ReturnType<typeof useCustomerTokenListLazyQuery>;
export type CustomerTokenListSuspenseQueryHookResult = ReturnType<typeof useCustomerTokenListSuspenseQuery>;
export type CustomerTokenListQueryResult = Apollo.QueryResult<CustomerTokenListQuery, CustomerTokenListQueryVariables>;
export const UpdateCustomerTokenDocument = gql`
    mutation UpdateCustomerToken($id: String!, $name: String, $environmentId: String!, $enabled: Boolean) {
  updateCustomerToken(
    input: {id: $id, environmentId: $environmentId, patch: {enabled: $enabled, name: $name}}
  ) {
    customerToken {
      ...CustomerTokenDetail
    }
  }
}
    ${CustomerTokenDetailFragmentDoc}`;

/**
 * __useUpdateCustomerTokenMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerTokenMutation, { data, loading, error }] = useUpdateCustomerTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      environmentId: // value for 'environmentId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateCustomerTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerTokenMutation, UpdateCustomerTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerTokenMutation, UpdateCustomerTokenMutationVariables>(UpdateCustomerTokenDocument, options);
      }
export type UpdateCustomerTokenMutationHookResult = ReturnType<typeof useUpdateCustomerTokenMutation>;
export type UpdateCustomerTokenMutationResult = Apollo.MutationResult<UpdateCustomerTokenMutation>;
export type UpdateCustomerTokenMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerTokenMutation, UpdateCustomerTokenMutationVariables>;
export const DeleteCustomerTokenDocument = gql`
    mutation DeleteCustomerToken($id: String!, $environmentId: String!) {
  deleteCustomerToken(input: {id: $id, environmentId: $environmentId}) {
    customerToken {
      ...CustomerTokenDetail
    }
  }
}
    ${CustomerTokenDetailFragmentDoc}`;

/**
 * __useDeleteCustomerTokenMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerTokenMutation, { data, loading, error }] = useDeleteCustomerTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteCustomerTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerTokenMutation, DeleteCustomerTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerTokenMutation, DeleteCustomerTokenMutationVariables>(DeleteCustomerTokenDocument, options);
      }
export type DeleteCustomerTokenMutationHookResult = ReturnType<typeof useDeleteCustomerTokenMutation>;
export type DeleteCustomerTokenMutationResult = Apollo.MutationResult<DeleteCustomerTokenMutation>;
export type DeleteCustomerTokenMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerTokenMutation, DeleteCustomerTokenMutationVariables>;